import usePDPBasicEvents from 'data-hooks/useEvents/usePDPBasicEvents';
const PDPPageAnalytics = () => {
  usePDPBasicEvents();
  return null;
};
export default PDPPageAnalytics;